import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Observable, catchError, delay, from, switchMap, tap, throwError } from 'rxjs';
import { AuthHelper } from '../auth/auth-helper';
import { environment } from '../../environments/environment';
import { inject } from '@angular/core';
import { MasterDataService } from '../services/master-data.service';

export const http401Interceptor: HttpInterceptorFn = (req, next) => {
  const masterDataService = inject(MasterDataService);
  return next(req).pipe(
    catchError((error: HttpErrorResponse, caught: Observable<any>) => {
      if (error.status === 401) {
        return from(AuthHelper.refreshAccessToken()).pipe(
          delay(1000),
          switchMap(() => {
            // Call user detail API after token refresh
            return from(masterDataService.getUser()).pipe(
              tap((user) => {
                AuthHelper.user = user;
              }),
              switchMap(() => {
                const updatedReq = req.clone({
                  setHeaders: {
                    Authorization: `Bearer ${AuthHelper.accessToken}`,
                    'Consumer-Key': environment.StarGateConsumerKey,
                  },
                });
                return next(updatedReq);
              }),
            );
          }),
        );
      } else {
        return throwError(() => error);
      }
    }),
  );
};
